export default "__VITE_ASSET__DglF$g33__"